//Library Imports
import styled from "styled-components";
import { useState } from "react";
import { useEffect } from "react";

//Local Imports
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import Button from "./Button";
import Checkbox from "./Checkbox";
import { useSelector } from "react-redux";
import { RootState } from "store";
import ConfirmDialogWithModal from "./ConfirmDialogWithModal";
interface ISelectedBottom {
  loading?: boolean;
  selectedCount?: number;
  selectedMessage?: string;
  // ask for confirmation
  askConfirmDelete?: boolean;
  askConfirmClearSelection?: boolean;
  confirmMessage?: string;
  confirmTitle?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  selectAllFlag?: boolean;
  setSelectAllFlag?: (value: boolean) => void;
  excludedWorkflowsIds?: number[];
  selectableWorkflowsCount?: number;
  // when action success hide it
  actionSuccess?: boolean;
  // action button
  actionText?: string;
  hideAction?: boolean;
  customAction?: any;
  actionHandler?: (value?: any) => void;
  onClearSelection?: (value?: any) => void;
  actionFirstText?: string;
}

const SelectedBottom: React.FC<ISelectedBottom> = (props) => {
  //Redux States
  const error: boolean = useSelector((state: RootState) => state.automation.deleteWorkflow.error);
  const userWorkflowsTotalCount: number = useSelector(
    (state: RootState) => state.automation.userWorkflows.totalCount
  );

  // Local States
  const [confirm, setConfirm] = useState(false);
  const [clearConfirm, setClearConfirm] = useState(false);
  const [showError, setShowError] = useState(false);

  // Props
  const {
    loading,
    selectedCount,
    selectedMessage,
    askConfirmDelete,
    askConfirmClearSelection,
    confirmTitle,
    hideAction,
    actionText,
    actionSuccess,
    actionHandler,
    onClearSelection,
    customAction,
    actionFirstText,
    selectAllFlag,
    excludedWorkflowsIds,
    selectableWorkflowsCount,
  } = props;

  // Component Logic
  const customActionHandler = () => {
    if (askConfirmDelete) {
      setConfirm(true);
    } else {
      if (actionHandler) actionHandler();
    }
  };

  const onConfirm = () => {
    if (actionHandler) actionHandler();
    setConfirm(false);
  };

  const onCancel = () => {
    setConfirm(false);
  };

  const handleClearSelection = () => {
    if (askConfirmClearSelection) {
      setClearConfirm(true);
    } else {
      if (onClearSelection) onClearSelection();
    }
    props.setSelectAllFlag && props.setSelectAllFlag(false);
  };

  const handleClearConfirm = () => {
    if (onClearSelection) onClearSelection();
  };

  const handleClearCancel = () => {
    if (onClearSelection) onClearSelection();
  };

  // for adding any messages when action success or fail
  useEffect(() => {
    if (actionSuccess) {
      setConfirm(false);
      setClearConfirm(false);
    }
  }, [actionSuccess]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  return (
    <Wrapper
      className={`${selectedCount && selectedCount > 0 ? "move-up" : ""
        } floating-footer d-flex justify-content-between`}
    >
      {confirm ? (
        // <DialogWrapper>
        //   <BackOverlay />
        <ConfirmDialogWithModal
          cancel={"Cancel"}
          confirm={"Yes"}
          onConfirm={onConfirm}
          onCancel={onCancel}
          // icon={whiteRoy}
          title={confirmTitle ? confirmTitle : "Are you sure to clear selection?"}
        />
        // </DialogWrapper>
      ) : null}
      {clearConfirm ? (
        // <DialogWrapper>
        //   <BackOverlay />
        <ConfirmDialogWithModal
          cancel={"Cancel"}
          confirm={"Confirm"}
          onConfirm={handleClearConfirm}
          onCancel={handleClearCancel}
          // icon={whiteRoy}
          title={confirmTitle ? confirmTitle : "Are you sure to clear selection?"}
        />
        // </DialogWrapper>
      ) : null}
      {showError ? (
        // <DialogWrapper>
        //   <BackOverlay />
        <ConfirmDialogWithModal
          confirm={"Okay"}
          onConfirm={() => setShowError(false)}
          title={"Sommething went wrong!"}
          titleQuestion={null}
        />
        // </DialogWrapper>
      ) : null}
      {/* Toggle Class sidbar-opend  */}
      <div id="selectedBarCheckBox" className="d-flex align-items-center">
        <div className="multi-select">
          <Checkbox checked={true} readOnly />
          <Checkbox checked={true} readOnly />
        </div>
        <span className="count">
          {selectAllFlag && excludedWorkflowsIds && excludedWorkflowsIds.length === 0
            ? selectableWorkflowsCount
            : selectAllFlag && excludedWorkflowsIds && excludedWorkflowsIds.length > 0
              ? selectableWorkflowsCount && selectableWorkflowsCount - excludedWorkflowsIds.length
              : selectedCount}{" "}
          {selectedMessage ? selectedMessage : "Selected"}
        </span>
        <span className="clear" onClick={handleClearSelection}>
          Clear selection
        </span>
      </div>
      {!hideAction && !customAction && (
        <div className="d-flex align-items-center">
          {actionFirstText && (
            <Button
              value={actionFirstText ? actionFirstText : "Action"}
              className={`me-2 px-3 btn-sm-secondary ${loading ? "disabled" : ""}`}
            />
          )}
          <Button
            value={actionText ? actionText : "Action"}
            className={`btn-sm-primary ${loading ? "disabled" : ""}`}
            onClick={customActionHandler}
          />
        </div>
      )}
    </Wrapper>
  );
};

export default SelectedBottom;

const BackOverlay = styled.div`
  position: fixed;
  background: grey;
  opacity: 0.2;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
`;

const Wrapper = styled.div`
  z-index: 1;
  transition: 1s;

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &.floating-footer {
    transition: 1s;
    background: #fff;
    border-top: 1px solid #e7e7e7;
    &.move-up {
      bottom: 0 !important;
      box-shadow: 0px -13px 10px rgb(0 0 0 / 10%);
    }
    position: fixed;
    bottom: -86px;
    left: 89px;
    width: calc(100% - 88px);
    padding: 20px 30px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
      left: 64px;
      padding: 10px 30px;
    }
    &.sidbar-opend {
      width: calc(100% - 634px);
    }
    .count {
      color: #7e7e7e;
      font-family: "Roboto Slab", serif;
      font-size: 18px;
      font-weight: 500;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
      }
    }
    .clear {
      cursor: pointer;
      color: #27ce0a;
      font-size: 12px;
      font-weight: 600;
      font-family: "Roboto Slab", serif;
      padding-left: 10px;
      margin-top: 4px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 2px;
      }
    }
    .multi-select {
      position: relative;
      width: 35px;
      height: 45px;
      > div {
        position: absolute;
        top: 10px;
        left: 0;
        z-index: 9;
        span {
          background-color: #fff;
        }
        + div {
          top: 15px;
          left: 5px;
          z-index: 8;
        }
      }
    }
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
`;
